import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getCouponList = createAsyncThunk(
  "get-coupon",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("coupon/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const createCoupon = createAsyncThunk(
  "create-coupon",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("coupon", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const editCoupon = createAsyncThunk(
  "edit-coupon",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`coupon/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const updateCoupon = createAsyncThunk(
  "update-coupon",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/coupon/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const deleteCoupon = createAsyncThunk(
  "delete-coupon",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/coupon/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const toggleCouponStatus = createAsyncThunk(
  "toggle-coupon-status",
  async ({ id, status }, { dispatch }) => {
    try {
      const response = await axios.patch(`/coupon/${id}/status`, { status });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

const couponSlice = createSlice({
  name: "coupon",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCouponList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCouponList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.couponList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getCouponList.rejected, (state) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default couponSlice.reducer;
